function last(array){var length=null==array?0:array.length;return length?array[length-1]:void 0}module.exports=last;